/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Manager가 테스트 보기 이전에 교육 수료 여부 상태
 */
export type ManagerEducationStatusType = 'Pending' | 'Completed';

export const ManagerEducationStatusType = {
    Pending: 'Pending' as ManagerEducationStatusType,
    Completed: 'Completed' as ManagerEducationStatusType
};

